function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4226_431)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.25 1.24333H8.75C7.36929 1.24333 6.25 2.36262 6.25 3.74333V31.2433C6.25 32.624 7.36929 33.7433 8.75 33.7433H36.25C37.6307 33.7433 38.75 32.624 38.75 31.2433V3.74333C38.75 2.36262 37.6307 1.24333 36.25 1.24333Z",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.75 38.7433H3.75C3.08696 38.7433 2.45107 38.4799 1.98223 38.0111C1.51339 37.5423 1.25 36.9064 1.25 36.2433V6.24333",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.25 11.2467V23.7467C16.25 23.9679 16.3087 24.1851 16.4202 24.3762C16.5316 24.5673 16.6917 24.7254 16.8843 24.8344C17.0768 24.9434 17.2948 24.9993 17.516 24.9965C17.7372 24.9937 17.9537 24.9322 18.1433 24.8183L28.1433 18.57C28.3283 18.4589 28.4814 18.3018 28.5877 18.114C28.694 17.9262 28.7499 17.7141 28.7499 17.4983C28.7499 17.2825 28.694 17.0704 28.5877 16.8826C28.4814 16.6948 28.3283 16.5377 28.1433 16.4267L18.1433 10.1783C17.9538 10.0652 17.7377 10.0041 17.517 10.0014C17.2963 9.99871 17.0788 10.0544 16.8865 10.1629C16.6943 10.2714 16.5342 10.4288 16.4224 10.6191C16.3106 10.8094 16.2511 11.0259 16.25 11.2467Z",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4226_431"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})));

function SvgVideoImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoImage);
export default __webpack_public_path__ + "static/media/video-image.a74ee21c.svg";
export { ForwardRef as ReactComponent };